import apiClient from 'services/_infra/apiClient';
import { loginfo } from 'services/_infra/util/apiUsageLogger';
import { tryMsAuthSilent } from 'services/auth/ms.service';

export async function createRole(roleName, members, permissions, layout) {
  try {
    loginfo();
    return await apiClient.post('/createFusionRole', {
      roleName,
      members,
      permissions,
      layout,
    });
  } catch (error) {
    console.error('createFusionRole failed.', error);
  }
}

export async function updateRole(roleId, roleName, members, permissions, layout) {
  try {
    loginfo();
    return await apiClient.post('/updateFusionRole', {
      roleId,
      roleName,
      members,
      permissions,
      layout,
    });
  } catch (error) {
    console.error('updateFusionRole failed.', error);
  }
}

export async function getRole(roleId) {
  try {
    loginfo();
    return await apiClient.post('/getFusionRoleById', { roleId });
  } catch (error) {
    console.error('getFusionRoleById failed.', error);
  }
}

export async function getAllRoles(instance = null) {
  const msRes = await tryMsAuthSilent(instance, ['Group.Read.All']);
  if (msRes) {
    try {
      loginfo();
      return await apiClient.post(
        '/getFusionRoles',
        {},
        {
          headers: { MsAuth: `Bearer ${msRes.accessToken}` },
        },
      );
    } catch (error) {
      console.error('getFusionRoles with MsAuth failed.', error);
    }
  } else {
    try {
      loginfo();
      return await apiClient.post('/getFusionRoles');
    } catch (error) {
      console.error('getFusionRoles failed.', error);
    }
  }
}

export async function deleteRole(deleteId) {
  try {
    loginfo();
    return await apiClient.post('/deleteRole', { deleteId });
  } catch (error) {
    console.error('deleteRole failed.', error);
  }
}

export async function updateRoleHierarchy(hierarchy) {
  try {
    loginfo();
    return await apiClient.post('/updateRoleHierarchy', { hierarchy });
  } catch (error) {
    console.error('updateRoleHierarchy failed.', error);
  }
}
